__turbopack_context__.v({
  "black-bt": "dropAuctionLive-module-scss-module__j4VUuG__black-bt",
  "border": "dropAuctionLive-module-scss-module__j4VUuG__border",
  "btnCustom": "dropAuctionLive-module-scss-module__j4VUuG__btnCustom",
  "globalHeading": "dropAuctionLive-module-scss-module__j4VUuG__globalHeading",
  "goAgianInner": "dropAuctionLive-module-scss-module__j4VUuG__goAgianInner",
  "goAgianSec": "dropAuctionLive-module-scss-module__j4VUuG__goAgianSec",
  "goItem": "dropAuctionLive-module-scss-module__j4VUuG__goItem",
  "goItemImg": "dropAuctionLive-module-scss-module__j4VUuG__goItemImg",
  "goItemInner": "dropAuctionLive-module-scss-module__j4VUuG__goItemInner",
  "goItemText": "dropAuctionLive-module-scss-module__j4VUuG__goItemText",
  "goItemsNew": "dropAuctionLive-module-scss-module__j4VUuG__goItemsNew",
  "image": "dropAuctionLive-module-scss-module__j4VUuG__image",
  "listCardTwoColumn": "dropAuctionLive-module-scss-module__j4VUuG__listCardTwoColumn",
  "liveAuctionBtn": "dropAuctionLive-module-scss-module__j4VUuG__liveAuctionBtn",
  "priceBox": "dropAuctionLive-module-scss-module__j4VUuG__priceBox",
  "priceInfoDesktop": "dropAuctionLive-module-scss-module__j4VUuG__priceInfoDesktop",
  "priceInfoMobile": "dropAuctionLive-module-scss-module__j4VUuG__priceInfoMobile",
  "proAuction": "dropAuctionLive-module-scss-module__j4VUuG__proAuction",
  "proBrand": "dropAuctionLive-module-scss-module__j4VUuG__proBrand",
  "proName": "dropAuctionLive-module-scss-module__j4VUuG__proName",
  "saleTime": "dropAuctionLive-module-scss-module__j4VUuG__saleTime",
  "seeMore": "dropAuctionLive-module-scss-module__j4VUuG__seeMore",
  "timerUpdate": "dropAuctionLive-module-scss-module__j4VUuG__timerUpdate",
});
